import { render, staticRenderFns } from "./EntryMessageReservationToApplicant.vue?vue&type=template&id=e6974c94"
import script from "./EntryMessageReservationToApplicant.vue?vue&type=script&lang=js"
export * from "./EntryMessageReservationToApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports